import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const PX_TO_MM = 0.2645833333;

export const generatePdfBlobUrlFromElement = async (element) => {
  if (!element) {
    throw new Error('No se encontro el contenido para generar el PDF.');
  }

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
    windowWidth: Math.max(element.scrollWidth, element.clientWidth),
    windowHeight: Math.max(element.scrollHeight, element.clientHeight)
  });

  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imageWidth = pageWidth;
  const imageHeight = canvas.height * PX_TO_MM;
  const scaledImageHeight = (imageHeight * pageWidth) / (canvas.width * PX_TO_MM);
  const imageData = canvas.toDataURL('image/png');

  let heightLeft = scaledImageHeight;
  let position = 0;

  pdf.addImage(imageData, 'PNG', 0, position, imageWidth, scaledImageHeight);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position = heightLeft - scaledImageHeight;
    pdf.addPage();
    pdf.addImage(imageData, 'PNG', 0, position, imageWidth, scaledImageHeight);
    heightLeft -= pageHeight;
  }

  const blob = pdf.output('blob');
  return URL.createObjectURL(blob);
};
